module.exports = __webpack_public_path__ + "img/caselist16.2dfbab59.jpg";